























































































































































































































































import { AuthErrorEvent } from '@/components/organisms/dialog/error-dialog/events'
import CrossPageTransition from '@/mixin/cross-page-transition'
import * as CurrentTime from '@/models/current-time/functions'

import { Either, Left, Right } from 'fp-ts/lib/Either'
import _ from 'lodash'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Emit, Prop, Watch } from 'vue-property-decorator'

import LoadingMixin, { Status } from '@spa/mixins/loading'
import { PluginMixin } from '@spa/mixins/plugin'

import { RawTag } from '@/models/api/tags'
import { AddressSearchInteraction } from '@spa/components/organisms/profile/addressFormState'
import { convertToRegionName } from '@spa/services/region'
import { User, UserState } from '@spa/store/modules/user/types'

import BehaviorConfig from '@/models/app-config/behavior/behavior'
import { SessionDataService } from '@/services/session/session-data-service'
import Password from '@/util/password'
import SpaAddressSearchButton from '@spa/components/organisms/AddressSearchButton.vue'
import MailMagazine from '@spa/components/organisms/mail-magazine/MailMagazine.vue'
import { Decorator, Decorators } from '@spa/components/organisms/mail-magazine/model'
import SpaPrefectureSelect from '@spa/components/organisms/PrefectureSelectBox.vue'
import { UserRegistrationPayload } from '@spa/services/api/auth'
import {
  RegistrationPayload,
} from '@spa/store/modules/user/actions'
import { createRegistrationPayload } from '@spa/store/modules/user/functions'

import { loadingFormParts, SignUpFormParts } from '@spa/components/pages/cart/model/signup/form-parts'
import { createSignUpFormParts } from '@spa/components/pages/cart/model/signup/form-parts-factory'
import { loadingPageParts, SignUpPageParts } from '@spa/components/pages/cart/model/signup/page-parts'
import { createSignUpPageParts } from '@spa/components/pages/cart/model/signup/page-parts-factory'

import { EventBusForThirdParty } from '@/usecases/event-bus-for-third-party/event-bus'
import Fade from '@spa/components/atoms/transition/Fade.vue'

Component.registerHooks([
  'beforeRouteEnter',
])

@Component({
  components: {
    SpaAddressSearchButton,
    SpaPrefectureSelect,
    MailMagazine,
    Fade,
  },
  mixins: [
    LoadingMixin,
  ],
})
export default class CartSignup extends Mixins<PluginMixin & CrossPageTransition>(PluginMixin, CrossPageTransition) {
  @Prop({ required: true })
  /**
   * ルーティング設定からの注入が基本
   */
  readonly next: string

  status: Status = Status.Pending

  email: string = ''
  password: string  = ''
  firstName: string = ''
  lastName: string = ''
  phoneticFirstName: string = ''
  phoneticLastName: string = ''
  zipcode: string = ''
  regionCode: string | null = null
  city: string = ''
  town: string = ''
  tel: string = ''
  isDelivery: boolean = true

  mailMagazines: RawTag[] = []

  /**
   * 画面に表示する内容が、フォーム入力内容の確認状態であるかどうかを示す。
   * ローディングに関する状態管理と統合して、SignUpコンポーネント自前の状態として定義しなおすことも検討したい。
   */
  isConfirming: boolean = false

  searchAddressEnabled: boolean = true

  currentTime = CurrentTime.create()

  behaviorConfig = new BehaviorConfig()

  pageParts: SignUpPageParts = loadingPageParts

  formParts: SignUpFormParts = loadingFormParts

  addressAutoSearchedAndFailed: boolean = false

  fieldsShouldBeEnabled: boolean = false

  mailMagazineLoaded = false

  initialized() {
    if (!this.isFailed) {
      this.status = Status.Pending
    }
    this.mailMagazineLoaded = true
  }

  get decorator(): Decorator {
    return Decorators.subscribeAll
  }

  get isLoading() {
    return this.status === Status.Loading
  }

  get isFailed() {
    return this.status === Status.Failed
  }

  get userState(): UserState {
    return this.$store.state.user
  }

  get error(): Error | null {
    return this.userState.error.register
  }

  get failSubscriptionMailMagazine(): boolean {
    return !!this.userState.error.mailMagazine
  }

  get isDuplicateError(): boolean {
    const cause: string = _.get(this.error, 'response.body.cause', '')

    return cause.includes('already exists')
  }

  get dummyPassword(): string {
    return Password.generateMasked()
  }

  /**
   * TODO: NameFormを利用する or バリデーションルールを共通化する
   */
  get nameValidation(): any {
    return {
      required: true,
      max: 10,
      regex: /^[^0-9・_\-　\s]+$/,
      unusable_emoji: true,
      unusable_character: true,
      contains_tab: true,
    }
  }

 // TODO: PhoneticNameForm コンポーネントから拝借。後で同コンポーネント自体を再利用すること
  get phoneticNameVaridation(): any {
    return {
      required: true,
      max: 10,
      regex: /^([ァ-ヴ][ァ-ヴー・]*)$/,
      unusable_emoji: true,
      unusable_character: true,
      contains_tab: true,
    }
  }

  /**
   * TODO: AddressForm.vueと同じ仕様であるべき実装なので共通化する
   * 他にも同様のメソッドはありそう。
   */
  get subAddressValidation(): any {
    return {
      required: true,
      /**
       * 配送システムの都合
       * @see https://github.com/Everforth/growthpalette-front/issues/8148
       */
      max: 48,
      unusable_character: true,
      contains_tab: true,
    }
  }

  get mailMagazinesWithFollow(): RawTag[] {
    return this.mailMagazines.filter(mailMagazine => mailMagazine.follow)
  }

  get validatorErrors(): Array<{ field: string }> {
    return this.$validator.errors.items
  }

  get hasPasswordValidationError(): boolean {
    return _.some(this.validatorErrors, e => e.field === 'password')
  }

  get showPasswordDescription(): boolean {
    if (this.password === '') {
      return true
    }

    return !this.hasPasswordValidationError
  }

  get user(): User {
    return this.$store.state.user.user
  }

  getPrefectureName(regionCode: string): string {
    return convertToRegionName(regionCode)
  }

  backToSignupPage(): void {
    if (!this.isFailed) {
      this.status = Status.Loading
    }
    this.isConfirming = false
    window.scrollTo(0, 0)
  }

  async created() {
    this.status = Status.Loading
    this.pageParts = createSignUpPageParts(this.behaviorConfig)
    this.formParts = createSignUpFormParts(this.behaviorConfig)
    this.fieldsShouldBeEnabled = this.addressOptionsAlreadyExists()

    await Promise.all([
      this.$store.dispatch('user/get'),
      new Promise((resolve) => {
        const unwatch = this.$watch('mailMagazineLoaded', (newVal: boolean, oldVal: boolean) => {
          // false -> true への遷移のみ
          if (!oldVal && newVal) {
            resolve()
            unwatch() // 一度のみ発火
          }
        })
      }),
    ])

    EventBusForThirdParty.getInstance().publish('page-initialized', {
      url: window.location.href,
      initializedAt: CurrentTime.create().now,
      user: this.user,
    })
  }

  /**
   * これらの実装は client/spa/src/components/organisms/profile/AddressForm.vue と重複している。
   * - onZipcodeChanged
   * - isValidFormatZipcode
   * - autoSearchAddress
   * - searchAddressAndFillForm
   *
   * TODO:
   * 本コンポーネントが各inputを直接描画するのでなく、AddressFormを利用できるように修正できないか検討する。
   * それができない/行うべきでない場合は手続きを別ファイルに切り出して共通化するかMixinの利用を検討する。
   */
  @Watch('zipcode')
  async onZipcodeChanged() {
    this.addressAutoSearchedAndFailed = false
    const isZipCodeValid = this.isValidFormatZipcode()
    if (isZipCodeValid) {
      const foundAddress = await this.autoSearchAddress()
      if (foundAddress.isLeft()) {
        this.addressAutoSearchedAndFailed = true
      }
    }
  }

  isValidFormatZipcode(): boolean {
    const regexZipcode = /^[0-9]{3}-?[0-9]{4}$/

    return regexZipcode.test(this.zipcode)
  }

  addressOptionsAlreadyExists(): boolean {
    return this.regionCode !== null && this.city !== '' && this.town !== ''
  }

  async beforeRouteEnter(to, _from, next) {
    if (await SessionDataService.userIsRegistered()) {
      next({
        path: this.next,
        query: to.query,
      })

      return
    }
    next()
  }

  async validateAll(): Promise<boolean> {
    return this.$validator.validateAll()
  }

  async submit() {
    if (await SessionDataService.userIsRegistered()) {
      this.emitError({ content: 'すでにログイン済みです' })

      return
    }

    window.scrollTo(0, 0)

    // Validations
    const validated = await this.validateAll()

    if (!validated) {
      this.emitError({ content: '入力内容が正しくありません' })

      return
    }

    this.registerNewProfileData()
  }

  async registerNewProfileData(): Promise<void> {

    if (!this.isConfirming) {
      this.isConfirming = true

      return
    }

    // Start loading
    this.status = Status.Loading

    // add registered_at
    const registeredAt = this.currentTime.now.toJSON()

    // Register new user
    const registerPayload: UserRegistrationPayload = {
      username: this.email,
      password: this.password,
      email: this.email,
      first_name: this.firstName,
      last_name: this.lastName,
      phonetic_first_name: this.phoneticFirstName,
      phonetic_last_name: this.phoneticLastName,
      zipcode: this.sanitizeZipcode(this.zipcode),
      region_id: this.regionCode,
      address1: this.city,
      address2: this.town,
      tel: this.tel,
      is_delivery: true,
      registered_at: registeredAt,
    }

    if (this.isDelivery) {
      registerPayload.display_level = 0
    }

    const payload: RegistrationPayload = createRegistrationPayload(
      registerPayload,
      this.mailMagazines
    )

    await this.$store.dispatch('user/register', payload)

    if (this.error) {
      this.isConfirming = false
      this.status = Status.Failed

      return
    }
    if (this.failSubscriptionMailMagazine) {
      this.isConfirming = false
      this.status = Status.Completed

      this.emitError({
        content: `
          会員登録は成功しましたが、メールマガジン登録に失敗しました。<br/>
          メールマガジンは、アカウントサービスから再登録できます。
        `,
        onCloseModal: () => this.moveToOrderPage(),
      })

      return
    }

    this.isConfirming = false
    this.status = Status.Completed
    this.moveToOrderPage()
  }

  async autoSearchAddress(): Promise<Either<Error, null>> {

    this.searchAddressEnabled = false

    try {
      await this.searchAddressAndFillForm()
    } catch (error) {

      return new Left(error)
    } finally {
      this.searchAddressEnabled = true
      this.fieldsShouldBeEnabled = true
    }

    return new Right(null)
  }

  async searchAddress() {
    // TODO: More validation?
    if (!this.zipcode) {
      this.emitError({ content: '郵便番号を入力してください' })

      return
    }

    this.searchAddressEnabled = false

    try {
      await this.searchAddressAndFillForm()

    } catch (error) {
      this.emitError({ content: '住所が取得できませんでした' })
    } finally {
      this.searchAddressEnabled = true
    }
  }

  async searchAddressAndFillForm(): Promise<void> {
    const addressSearchInteraction = new AddressSearchInteraction()
    const addressSearchResult = await addressSearchInteraction.search(this.zipcode)

    this.regionCode = addressSearchResult.prefectureCode
    this.city = addressSearchResult.city
    this.town = addressSearchResult.town
  }

  sanitizeZipcode(zipcode: string) {
    if (!zipcode) {
      return zipcode
    }

    return zipcode.replace('-', '')
  }

  onUpdateMailMagazine(updated: RawTag[]): void {
    this.mailMagazines = updated
  }
  failLoadMailMagazines() {
    this.mailMagazineLoaded = true
    this.emitError({
      content: `
        メールマガジン情報が取得できませんでした。<br/>
        ※改善されない場合、お問い合わせよりカスタマーセンターまでお問い合わせください。
      `,
    })
  }

  private moveToOrderPage() {
    this.goTo(this.next)
  }

  @Emit('error')
  private emitError(_event: AuthErrorEvent) {
    // only emit event
  }
}
